import React, { useCallback } from 'react';

import styles from '../../Analytics.module.scss';
import { ConfirmationModal } from '../../../../shared/modal/ConfirmationModal';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/react-redux';
import { getRecalculateConfirmationModalOpen, recalculateMyDocumentRiskToleranceStarted, toggleRecalculateConfirmationModal } from '../../store';
import { Calculator, WarningSign } from '../../../../shared/icons';
import { ModalHeader } from '../../../../shared/modal/ModalHeader';
import { Icon } from '../../../../shared/icon/Icon';

const { amber } = styles;

export const RecalculateConfirmationModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(getRecalculateConfirmationModalOpen);

    const closeModal = useCallback(() => dispatch(toggleRecalculateConfirmationModal(false)), [dispatch]);
    const recalculate = useCallback(() => dispatch(recalculateMyDocumentRiskToleranceStarted()), [dispatch]);

    if (!isOpen) {
        return null;
    }

    return (
        <ConfirmationModal
            isOpen
            closeModal={closeModal}
            confirm={recalculate}
            confirmLabel='Recalculate'
        >
            <div className={styles.recalculateConfirmationModalWrapper}>
                <ModalHeader
                    testId='recalculate-risk-tolerance-modal'
                    label='Recalculate Risk Tolerance'
                    icon={Calculator}
                />
                <div className={styles.recalculateModalContent}>An element of the risk tolerance has been updated which means the current calculated risk tolerance of your document portfolio may have changed.</div>
                <div className={styles.modalWarning}>
                    <Icon icon={WarningSign} color={amber} />
                    <div className={styles.modalWarningTitle}>The process of recalculating the risk tolerance of all outdated documents could take a long time, depending on the number of affected documents. You will not be able to make further changes to the risk configuration while this is recalculated.</div>
                </div>
                <div className={styles.recalculateModalContent}>If you do nothing now, our automatic overnight engine will recalculate the updated risk score of your portfolio</div>
            </div>
        </ConfirmationModal>
    );
};
